import { yupResolver } from '@hookform/resolvers/yup'
import { display, margin, width } from '@mui/system'
import moment from 'moment/moment'
import React, { forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row
} from 'reactstrap'
import ResponsiveDatePickers from '../../../components/date-picker/index'
import { InputEmail, InputNumber, InputPhone, InputText } from '../../../components/inputs'
import AreaFilter from '../../area/components/filter-area/area-filter'
import { getTransactions, setInitialData, setProductsCreditAction, setUserAction } from '../store'
import { SchemaValidations } from './validations'
import { sendFiltersAdapter } from '../adapters'
import { invoicesdb } from '../db/invoices'
import { departmentsOptions } from '../db/departments'
import { municipalityOptions } from '../db/municipalities'
import { districtsOptions } from '../db/districts'
import { economicActivity } from '../db/economicActivity'
import { clientsdb } from '../db/users'
import toast from 'react-hot-toast'
import SearchInput from './searchInput'
import { addUserAction, editUserAction, getData } from '../../customer-master/store'
// import InputEmail from '../../../components/inputs'
import Cleave from 'cleave.js/react'
import classnames from 'classnames'
import { contributorTypedb } from '../../customer-master/db/contributorType'
import InputInternationalPhone from '../../../components/inputs/internationalPhone'
import { addClient, editClient } from '../../customer-master/thunks'

const initialFilterProps = {
  clientCode: '',
  codeType: '',
  dteType: '',
  company: '',
  receiverEmail: '',
  receiverPhoneNumber: '',
  receiverName: '',
  startDate: moment().subtract(1, 'day'),
  endDate: null,
  address: '',
  department: null,
  municipality: null,
  district: null,
  DUI: '',
  NIT: '',
  NRC: '',
  dui: '',
  nit: '',
  nrc: '',
  EconomicActivity: null,
  economicActivity: null,
  economicActivity: null,
  tradeName: '',
  largeConsumer: null,
  dteClientType: null,
  country: null




}

const CreateUserForm =  forwardRef((onFilter , ref) => {
  const [filterProps, setFilterProps] = useState(initialFilterProps)
  const [areaFilterValue, setAreaFilterValue] = useState(null)
  const [NITValue, setNITValue] = useState('')
  const [nameValue, setNameValue] = useState('')
  const [isEdited, setIsEdited] = useState(false)
  const [clientId, setClientId] = useState(null)
  const dispatch = useDispatch()

  const { isPending } = useSelector((state) => state.transactions)
  const { data } = useSelector(state => state.customerMaster)
  const { countries, departments, cities, districts, economicActivities, documentTypes, receptor, taxpayerTypes, personTypes } = useSelector(state => state.invoiceIssuance)

  // CAT-091 desde el backend: sus id cambian entre ambientes, así que la lista
  // estática solo sirve de respaldo para no dejar el select vacío
  const hayTaxpayerTypes = Array.isArray(taxpayerTypes) && taxpayerTypes.length > 0
  const contributorOptions = hayTaxpayerTypes ? taxpayerTypes : contributorTypedb
  const otroContributorId = contributorOptions.find(item => item.value === '04')?.id
  // El campo "Tipo de contribuyente" solo se muestra para CCF (03); para el
  // resto el valor sale del default. Además, los clientes antiguos pueden
  // traer guardado un valor que no pertenece a CAT-091 (se guardaban países).
  // Por eso solo se acepta lo que exista en el catálogo: cualquier otra cosa
  // cae a "Otro", que es el valor por defecto correcto
  const idContribuyente = (seleccion) => {
    const enCatalogo = contributorOptions.find(item => item.value === seleccion?.value)
    return Number(enCatalogo?.id ?? otroContributorId) || null
  }
  const hayPersonTypes = Array.isArray(personTypes) && personTypes.length > 0
  const idTipoPersona = (codigo) => Number(personTypes.find(item => item.value === codigo)?.id) || null
  // CAT-019 code 10005 = "Otros": respaldo cuando no se elige actividad
  const idActividadOtros = Number(economicActivities?.find?.(item => item.value === '10005')?.id) || null

  const matchesReceptorAddress = (district) =>
    district.department === receptor?.department?.value &&
    district.municipality === receptor?.municipality?.value
  let districtOptions = districtsOptions.filter(matchesReceptorAddress)

  if (Array.isArray(districts) && districts.length) {
    districtOptions = districts
  }

  const [entitySelected, setEntity] = React.useState(null);
  const [code, setCode] = useState('');

  const filtereddocumentTypes = documentTypes?.filter ? documentTypes?.filter(item =>
    invoicesdb.some(val => val.value === item.value)
  ) : [];

  // useForm
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    trigger,
    formState: { errors }
  } = useForm({
    defaultValues: {
      ...initialFilterProps
    },
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(SchemaValidations(28000))
  })

  useImperativeHandle(ref, () => ({
    validateForm: () => {
        return trigger(); // Ejecuta todas las validaciones
    },
    resetForm: () => {
      reset(); // Reset the form
      setIsEdited(false)
    }
  }));

  const watchedFields = watch();
  const prevFieldsRef = useRef(watchedFields);

  useEffect(() => {
    const currentFields = watchedFields;
    const prevFields = prevFieldsRef.current;
    if (JSON.stringify(currentFields) !== JSON.stringify(prevFields)) {
      dispatch(setUserAction(currentFields));
    }
    prevFieldsRef.current = currentFields;
  }, [watchedFields, dispatch]);
  

  const onSubmit = (submitData) => {
    if (isEdited) {

      const storeUser = data.find(client => client.id === clientId);

      dispatch(editUserAction({...storeUser, ...submitData}))

      dispatch(editClient({...submitData,
        municipalityId: Number(submitData.municipality?.id),
        departmentId: Number(submitData.department?.id),
        districtId: Number(submitData.district?.id) || null,
        typeEntityId: idTipoPersona(submitData.dteType?.value === '01' ? '1' : '2'),
        largeConsumerId: idContribuyente(submitData?.largeConsumer),
        dteClientTypeId: submitData?.dteType?.id, // submitData.dteClientType?.value,
        clientCode: "123456789", // validar si es necesario
        dteTypeId: submitData?.dteType?.id,
        company: submitData.receiverName,
        economicActivityId: Number(submitData?.economicActivity?.id) || idActividadOtros,
        dui: submitData.dteType?.value === "01" ? submitData.dui : submitData.nit,
        codeTypeId: 1,
        id: clientId,
        country: submitData?.country?.id || null
      }))
      .unwrap()
      .then(() => {
        toast.success("Cliente Editado con éxito")
      })
      .catch(error => {
        console.error('Error updating user:', error);
      });

    } else {
        dispatch(addClient({...submitData,
          municipalityId: Number(submitData.municipality?.id) || 528,
          departmentId: Number(submitData.department?.id) || 15,
          districtId: Number(submitData.district?.id) || null,
          typeEntityId: idTipoPersona(submitData.dteType?.value === '01' ? '1' : '2'),
          largeConsumerId: idContribuyente(submitData?.largeConsumer),
          dteClientTypeId: submitData?.dteType?.id,
          clientCode:null,
          dteTypeId: submitData?.dteType?.id,
          company: submitData.receiverName,
          economicActivityId: Number(submitData?.economicActivity?.id) || idActividadOtros,
          dui: submitData.dteType?.value === "01" ? submitData.dui : submitData.nit,
          codeTypeId: 1,
        country: submitData?.country?.id || null

        }))

      toast.success("Cliente creado")

    }
  }
  useEffect(() => {
    dispatch(getData({}))

  }, [])

  const enterCustomerFound = (Client) => {

    setValue('largeConsumer', Client.largeConsumer)    
    dispatch(setUserAction(Client))
    setValue('nrc', Client.nrc)
    setValue('dui', Client.dui)
    setValue('clientCode', Client.clientCode)
    setValue('dteType', Client.dteType)
    setValue('company', Client.company)
    setValue('receiverEmail', Client.receiverEmail)
    setValue('receiverPhoneNumber', Client.receiverPhoneNumber)
    setNameValue(Client.receiverName)
    setValue('receiverName', Client.receiverName)
    setValue('tradeName', Client.tradeName)
    setValue('nit', Client.nit)
    setNITValue(Client.NIT)
    
    setValue('dteClientType', Client.dteClientType)
    console.log("Client.country: ", Client.country)
    setValue('country', Client.country)
    if (Client.country && Client.country?.value !== "SV") {
      setValue('municipality', { id: "572", label: "Otro (Para extranjeros)", value: "00"})
      setValue('department', { id: "29", label: "Otro (Para extranjeros)", value: "00"})
      setValue('district', { label: "Otro (Para extranjeros)", value: "00"})
    } else {
      setValue('municipality', Client.municipality)
      setValue('department', Client.department)
      setValue('district', Client.district)
    }

    setValue('economicActivity', Client.economicActivity)
    setValue('address', Client.address)
    setValue('emisionType', Client.dteType.value)
    setIsEdited(true)
    setClientId(Client.id)
    setFilterProps({...filterProps, dteType: Client.dteType.value})
  };

  const handleOnchangeSelectEntity = (e) => {
    setEntity(e.value);
    
    if (receptor?.dteType !== "14") {
      //setValue('country', null)
    }
  };

  useEffect(() => {
    // Genera un código aleatorio cuando el componente se monta
    const generateRandomCode = () => {
      const randomCode = Math.random().toString(36).substring(2, 10).toUpperCase();
      setCode(randomCode);
    };

    generateRandomCode();
  }, []);

  const handleClear = () => {
    reset({
      clientCode: '',
      codeType: '',
      dteType: '',
      company: '',
      receiverEmail: '',
      receiverPhoneNumber: '',
      receiverName: '',
      tradeName: '',
      EconomicActivity: null,
      NIT: '',
      DUI: '',
      NRC: '',
      dui:'',
      nit:'',
      nrc:'',
      department: null,
      municipality: null,
      district: null,
      address: '',
      typeEntity: null,
      dteType: null,
      largeConsumer: null,
      dteClientType: null,
      economicActivity: null,
      country: null
    })
    setValue('NIT', "")
    setValue('NRC', "")
    setValue('tradeName', "")
    
    setIsEdited(false)
    
  }

  useEffect(() => {
    if (filterProps?.dteType === '01' || filterProps?.dteType === '14') {
      setValue('dteClientType', { value: 'dui', label: 'DUI' })
    } else {
      setValue('dteClientType',{ value: 'nit', label: 'NIT' })
    }
    console.log("filterProps: ", filterProps)


  },[filterProps])

  useEffect(() => {
    if (receptor.country && receptor?.country?.value !== "SV") {
      setValue('municipality', { id: "572", label: "Otro (Para extranjeros)", value: "00"})
      setValue('department', { id: "29", label: "Otro (Para extranjeros)", value: "00"})
      setValue('district', { label: "Otro (Para extranjeros)", value: "00"})
    }
  },[receptor.country])

  const economicActivityWithCombinedLabel = (economicActivities || {}).map ? economicActivities.map(option => ({
    ...option,
    label: `${option.value} - ${option.label}`,
  })) : [];

  return (
    <Fragment>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Card>
          <CardHeader className="flex-md-row flex-column align-md-items-center align-items-start border-bottom">
            <CardTitle tag="h4">Información del cliente</CardTitle>
          </CardHeader>
          <Row className="mx-0" style={{ paddingTop: "2%", paddingLeft: "5%" }}>
            <Col>
              <SearchInput
                itemList={clientsdb}
                label={"Nombre de cliente o empresa*"}
                defaultvalueInput={nameValue}
                errors={errors}
                control={control}
                action={enterCustomerFound}
                searchType={"receiverName"}
                database={data}
                options={{
                  id: "receiverName",
                  name: "receiverName",
                }}
              />
            </Col>
            <Col>
              <Label className="me-1">Tipo de documento del cliente*</Label>
              <Controller
                name="dteClientType"
                control={control}
                render={({ field }) => (
                  <>
                    <Select
                      {...field}
                      options={[
                        { value: "dui", label: "DUI" },
                        { value: "nit", label: "NIT" },
                      ]}
                      isDisabled={receptor?.dteType?.value !== "14"}
                    />
                    {errors.dteClientType && (
                      <FormFeedback className="d-block">
                        {errors.dteClientType.message}
                      </FormFeedback>
                    )}
                  </>
                )}
              />
            </Col>
            
            {filterProps?.dteType === "01" && filterProps?.dteType !== null && (
              <Col>
                <SearchInput
                  itemList={clientsdb}
                  label={"DUI*"}
                  errors={errors}
                  control={control}
                  searchType={"dui"}
                  database={data}
                  action={enterCustomerFound}
                  options={{
                    id: "dui",
                    name: "dui",
                  }}
                  mascara={"dui"}
                />
              </Col>
            )}

            {filterProps?.dteType !== "01" && (
              <>
                <Col>
                  <SearchInput
                    itemList={clientsdb}
                    label={receptor?.dteType?.value !== "14" ? "NIT*" : "NIT o Documento de identidad"}
                    errors={errors}
                    control={control}
                    searchType={"NIT"}
                    database={data}
                    action={enterCustomerFound}
                    options={{
                      id: "nit",
                      name: "nit",
                    }}
                    mascara={(filterProps?.dteType === "11" || filterProps?.dteType === "14") ? null : "nit"}
                  />
                </Col>
                {filterProps?.dteType !== "01" &&
                  filterProps?.dteType !== null &&
                  filterProps?.dteType !== "11" && 
                  filterProps?.dteType !== "14" && (
                    <Col>
                      <Label className="me-1">NRC*</Label>
                      <Controller
                        id="nrc"
                        name="nrc"
                        control={control}
                        rules={{
                          required: "El NRC es requerido",
                          pattern: {
                            value: /^[0-9]{1,8}$/,
                            message:
                              "El NRC debe tener entre 1 y 8 dígitos numéricos",
                          },
                        }}
                        render={({ field }) => {
                          return (
                            <Cleave
                              options={{
                                numericOnly: true, // Solo permite números
                                delimiter: "-",
                                blocks: [8],
                              }}
                              className={classnames("form-control")}
                              {...field}
                            />
                          );
                        }}
                      />
                      <FormFeedback className="d-block">
                        {errors?.nrc?.message}
                      </FormFeedback>
                    </Col>
                  )}
              </>
            )}
            <Col style={{ display: "none" }}>
              <Label for="consecutive">Correlativo</Label>
              <Input
                type="text"
                name="consecutive"
                id="consecutive"
                value={code}
                readOnly
              />
            </Col>
          </Row>
          <Row className="mx-0" style={{ paddingTop: "2%", paddingLeft: "5%" }}>
            <Col md="6" sm="12">
              <Label className="me-1">Tipo de documento a emitir</Label>
              <Controller
                name="dteType"
                control={control}
                render={({ field }) => (
                  <>
                    <Select
                      {...field}
                      options={filtereddocumentTypes}
                      isDisabled={isEdited}
                      onChange={(e) => {
                        setFilterProps({ ...filterProps, dteType: e.value });
                        handleOnchangeSelectEntity(e);
                        //field.onChange(e.value)
                        field.onChange({
                          value: e.value,
                          label: e.label,
                          id: e.id,
                        });
                      }}
                    />
                    {errors.dteType && (
                      <FormFeedback className="d-block">
                        {errors.dteType.message}
                      </FormFeedback>
                    )}
                  </>
                )}
              />
            </Col>
          </Row>
          {filterProps?.dteType !== "01" && (
            <Row
              className="mx-0"
              style={{ paddingTop: "2%", paddingLeft: "5%" }}
            >
              <Col>
                <Label className="me-1">Nombre comercial*</Label>
                <Controller
                  name="tradeName"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Input
                        {...field}
                        errors={errors}
                        options={{
                          control,
                          id: "tradeName",
                          name: "tradeName",
                          // disabled: true
                        }}
                      />
                      {errors.tradeName && (
                        <FormFeedback className="d-block">
                          {errors.tradeName.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                />
              </Col>
              <Col>
                <Label className="me-1">Actividad económica</Label>
                <Controller
                  name="economicActivity"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Select
                        {...field}
                        options={economicActivityWithCombinedLabel}
                      />
                      {errors.economicActivity && (
                        <FormFeedback className="d-block">
                          {errors.economicActivity.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                />
              </Col>
            </Row>
          )}

          <Row className="mx-0" style={{ paddingTop: "2%", paddingLeft: "5%" }}>

              <Col md="6" sm="12">
                <InputInternationalPhone
                  label={"Teléfono*"}
                  errors={errors}
                  control={control}
                  options={{
                    id: "receiverPhoneNumber",
                    name: "receiverPhoneNumber",
                  }}
                />
              </Col>

            <Col md="6" sm="12">
              <InputEmail
                label="Correo Electrónico*"
                errors={errors}
                control={control}
                options={{
                  id: "receiverEmail",
                  name: "receiverEmail",
                }}
              />
            </Col>
            {(filterProps?.dteType === "11" || filterProps?.dteType === "14") && (
              <Col md="6" sm="12">
                <Label className="me-1">País</Label>
                <Controller
                  name="country"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Select {...field} options={countries} />
                      {errors.country && (
                        <FormFeedback className="d-block">
                          {errors.country.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                />
              </Col>
            )}
          </Row>

          {
            /*filterProps?.dteType !== '01'*/ true && (
              <>
                {filterProps?.dteType !== "11" && (
                  <>
                    <Row
                      className="mx-0"
                      style={{ paddingTop: "2%", paddingLeft: "5%" }}
                    >
                      <Col md="6" sm="12">
                        <Label className="me-1">Departamento*</Label>
                        <Controller
                          name="department"
                          control={control}
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                options={departments}
                                isDisabled={receptor.country && receptor.country?.value !== "SV"}
                                onChange={(e) => {
                                  field.onChange(e)
                                  setValue('municipality', null)
                                  setValue('district', null)
                                }}
                              />
                              {errors.department && (
                                <FormFeedback className="d-block">
                                  {errors.department.message}
                                </FormFeedback>
                              )}
                            </>
                          )}
                        />
                      </Col>
                      <Col md="6" sm="12">
                        <Label className="me-1">Municipio*</Label>
                        <Controller
                          name="municipality"
                          control={control}
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                options={cities}
                                isDisabled={receptor.country && receptor.country?.value !== "SV"}
                                onChange={(e) => {
                                  field.onChange(e)
                                  setValue('district', null)
                                }}
                              />
                              {errors.municipality && (
                                <FormFeedback className="d-block">
                                  {errors.municipality.message}
                                </FormFeedback>
                              )}
                            </>
                          )}
                        />
                      </Col>
                    </Row>
                    <Row
                      className="mx-0"
                      style={{ paddingTop: "2%", paddingLeft: "5%" }}
                    >
                      <Col md="6" sm="12">
                        <Label className="me-1">Distrito*</Label>
                        <Controller
                          name="district"
                          control={control}
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                options={districtOptions}
                                isDisabled={(receptor.country && receptor.country?.value !== "SV") || !receptor?.municipality?.value}
                              />
                              {errors.district && (
                                <FormFeedback className="d-block">
                                  {errors.district.message}
                                </FormFeedback>
                              )}
                            </>
                          )}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                <Row
                  className="mx-0"
                  style={{ paddingTop: "2%", paddingLeft: "5%" }}
                >
                  <Col md="6" sm="12">
                    <Label className="me-1">Dirección*</Label>
                    <Controller
                      name="address"
                      control={control}
                      render={({ field }) => (
                        <>
                          <Input
                            {...field}
                            errors={errors}
                            options={{
                              control,
                              id: "address",
                              name: "address",
                              // disabled: true
                            }}
                          />
                          {errors.address && (
                            <FormFeedback className="d-block">
                              {errors.address.message}
                            </FormFeedback>
                          )}
                        </>
                      )}
                    />
                  </Col>
                  {filterProps?.dteType === "03" && (
                    <Col>
                      <Label className="me-1">Tipo de contribuyente</Label>
                      <Controller
                        name="largeConsumer"
                        control={control}
                        render={({ field }) => (
                          <>
                            <Select {...field} options={contributorOptions} />
                            {errors.largeConsumer && (
                              <FormFeedback className="d-block">
                                {errors.largeConsumer.message}
                              </FormFeedback>
                            )}
                          </>
                        )}
                      />
                    </Col>
                  )}
                </Row>
              </>
            )
          }
          <Row className="mx-0" style={{ paddingLeft: "5%" }}>
            <Col className="d-flex align-items-left justify-content-sm-left my-3">
              <Button
                style={{ size: "10px", width: "200px" }}
                color="primary"
                type="submit"
                //onClick={handleClearFilters}
              >
                {isEdited ? "Editar Cliente" : "Crear Cliente"}
              </Button>
            </Col>
            {isEdited && (
              <Col className="d-flex align-items-center justify-content-end my-3">
                <Button
                  style={{ size: "10px", width: "200px" }}
                  type="reset"
                  color="secondary"
                  outline
                  onClick={handleClear}
                >
                  Limpiar
                </Button>
              </Col>
            )}
          </Row>
        </Card>
      </Form>
    </Fragment>
  );
})

export default CreateUserForm